<template>
  <div class="online-account-dialog-container">
    <div class="box-container">
      <h3>töltsd le a K&H számlanyitás alkalmazást</h3>
      <div class="qr-code-container">
        <img :src="qrCode" alt="QR" height="180px" />
      </div>
    </div>
  </div>
</template>

<script>
import "./_vpd-online-account.scss";
import qrCode from "@/assets/qr-code.svg";

export default {
  name: "vpd-online-account",
  data() {
    return {
      qrCode
    }
  }
};
</script>
